export default "__VITE_ASSET__m0MKPmeL__"